import { render, staticRenderFns } from "./AddUserCompanyPage.vue?vue&type=template&id=2a38cf03&"
import script from "./AddUserCompanyPage.vue?vue&type=script&lang=js&"
export * from "./AddUserCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports